
// import { GraphQLClient } from 'graphql-request';
import getConfig from 'next/config';
// import { send } from 'utils/http';
import { createClient } from '@supabase/supabase-js';

const {
  publicRuntimeConfig,
  serverRuntimeConfig
} = getConfig();

const connector = createClient(
  publicRuntimeConfig.API_URL,
  publicRuntimeConfig.API_PUBLIC_KEY
);

// available only on the serverside
const serverConnector = serverRuntimeConfig
  && serverRuntimeConfig?.API_URL
  && createClient(
    serverRuntimeConfig?.API_URL,
    serverRuntimeConfig?.API_PRIVATE_KEY
  );

export function getConnectorForSchema (schemaName) {
  return createClient(
    publicRuntimeConfig.API_URL,
    publicRuntimeConfig.API_PUBLIC_KEY,
    { db: { schema: schemaName } }
  );
}

export function getServerConnectorForSchema (schemaName) {
  return serverRuntimeConfig
    && serverRuntimeConfig?.API_URL
    && createClient(
      serverRuntimeConfig?.API_URL,
      serverRuntimeConfig?.API_PRIVATE_KEY,
      { db: { schema: schemaName } }
    );
}

// const client = new GraphQLClient(
//   serverRuntimeConfig.GRAPHQL_ADDR,
//   {
//     headers: {
//       "Content-Type": "application/json",
//       "api-version": "10"
//     }
//   }
// );

// export async function gqlClient () {
//   // TODO: add support to deal with tokens and permissions
//   return client;
// }

// export async function gqlPublicClient () {
//   return client;
// }

// export async function fetcher (query, variables) {
//   const client = await gqlClient();
//   return new Promise((resolve, reject) => {
//     client.request(query, variables)
//       .then(data => resolve({data}))
//       .catch(error => {
//         resolve({error});
//       });
//   });
// }

// export async function publicFetcher (query, variables) {
//   const client = await gqlPublicClient();
//   return new Promise((resolve, reject) => {
//     client.request(query, variables)
//       .then(data => resolve({data}))
//       .catch(error => {
//         resolve({error});
//       });
//   });
// }

async function extractAccessTokenFromCookie (req) {
  if (typeof window !== 'undefined') {
    // running client site
    // @ts-ignore
    return (await window.cookieStore.get("access_token"))?.value || null;
  } else {
    // in server side
    return serverRuntimeConfig?.API_PRIVATE_KEY;
    // req?.cookies?.access_token || req.access_token || null;
  }
}

function isClient () {
  return typeof window !== 'undefined';
}

async function queryExecutor (query, variables, req) {
  const accessToken = await extractAccessTokenFromCookie(req);
  // const url = publicRuntimeConfig.GRAPHQL_ADDR;
  // const url = publicRuntimeConfig.GRAPHQL_ADDR;
  const url = serverRuntimeConfig.API_URL + '/graphql/v1';

  const apikey = isClient()
    ? publicRuntimeConfig?.API_PUBLIC_KEY
    : serverRuntimeConfig?.API_PRIVATE_KEY;

  const opts = {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      apikey,
      Authorization: undefined
    },
    body: JSON.stringify({
      query,
      variables
    })
  };

  if (accessToken) {
    opts.headers.Authorization = 'Bearer ' + accessToken;
  }

  const response = await fetch(url, opts);

  const responseJSON = await response.json();
  if (responseJSON.errors) {
    responseJSON.error = responseJSON.errors;
    delete responseJSON.errors;
  }
  return responseJSON;
}

if (serverConnector) {
  // @ts-ignore
  serverConnector.query = queryExecutor;
  // @ts-ignore
  serverConnector.mutate = queryExecutor;
  // @ts-ignore
  serverConnector.execute = serverConnector.rpc; // just an alias
}

// @ts-ignore
connector.query = queryExecutor;
// @ts-ignore
connector.mutate = queryExecutor;

export {
  connector,
  serverConnector,
  // send
};

// export default client;
